
// src/reducers/native-router.js

export default function(state = {}) {
  return state  // do nothing for Web app
}



// WEBPACK FOOTER //
// ./src/reducers/native-router.js